import { Button, Flex, Input, Modal } from "src/elements";
import { useState } from "react";
import { useApi } from "src/api";
import { useModals } from "src/components/Modals";
import { useLoaders } from "src/components/InlineLoader";
import { RoutePutAuthPassword } from "@CommonApi/auth/password";
import { useToasts } from "src/components/Toasts";
import { isPasswordValid, validatePassword } from "src/utils/passwordValidation";

export const ChangeOwnPasswordModal = () => {
  const { closeModal } = useModals();
  const { putAuthPasswordApi } = useApi();
  const { hasLoader } = useLoaders();
  const { toast } = useToasts();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isCurrentPasswordVisible, setIsCurrentPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [isChangeSuccessful, setIsChangeSuccessful] = useState(false);
  const isChangeLoading = hasLoader(RoutePutAuthPassword);

  const newPasswordError = validatePassword(newPassword);
  const canSubmit = currentPassword !== "" && isPasswordValid(newPassword);

  const changePassword = async () => {
    const response = await putAuthPasswordApi({ currentPassword, newPassword });

    if (response) {
      setIsChangeSuccessful(true);
      toast({ type: "SUCCESS", title: "Password changed successfully" });

      setTimeout(() => {
        closeModal("ChangeOwnPasswordModal");
      }, 1000);
    }
  };

  return (
    <Modal name="ChangeOwnPasswordModal" title="Change Password" width="320px">
      <Flex padding="20px" column gap="20px">
        <Input
          type={isCurrentPasswordVisible ? "text" : "password"}
          value={currentPassword}
          setValue={setCurrentPassword}
          title="Current Password"
          placeholder="Enter current password"
          rightIcon={{
            name: isCurrentPasswordVisible ? "eyeOn" : "eyeOff",
            onClick: () => setIsCurrentPasswordVisible(!isCurrentPasswordVisible),
          }}
        />

        <Input
          type={isNewPasswordVisible ? "text" : "password"}
          value={newPassword}
          setValue={setNewPassword}
          title="New Password"
          placeholder="Enter new password"
          error={newPasswordError}
          rightIcon={{
            name: isNewPasswordVisible ? "eyeOn" : "eyeOff",
            onClick: () => setIsNewPasswordVisible(!isNewPasswordVisible),
          }}
        />

        <Flex justify="center">
          <Button
            isDisabled={!canSubmit}
            isLoading={isChangeLoading}
            isSuccessful={isChangeSuccessful}
            onClick={changePassword}
          >
            Change Password
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
